import ComponentLayout from "../../../../src/layouts/component-layout";
import { ButtonVariants, ButtonSizes } from '@primer/react-brand';
import { SearchIcon, ChevronDownIcon, FilterIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  ComponentLayout,
  ButtonVariants,
  ButtonSizes,
  SearchIcon,
  ChevronDownIcon,
  FilterIcon,
  PropTableValues,
  Link,
  React
};